module.exports = __webpack_public_path__ + "js/multiple-pdf-worker.55f5eaba.worker.js"